import React, { useEffect, useState } from 'react';
import { Button, CircularProgress, Box, Typography, TableHead, Tab, TableCell, Table, TableBody, TableRow, TablePagination } from '@mui/material';
import { fetchStixifyProfiles, Profile } from '../../../services/stixify_api.ts';
import { Link } from 'react-router-dom';
import { URLS } from '../../../services/urls.ts';

const PAGE_SIZE = 50

const StixifyProfiles: React.FC = () => {
  const [data, setData] = useState<Profile[]>([]);
  const [loading, setLoading] = useState<boolean>(false); // Loading state
  const [page, setPage] = useState<number>(0); // Current page
  const [pageSize, setPageSize] = useState<number>(10); // Profiles per page
  const [dataCount, setDataCount] = useState<number>(0); // Total number of pages


  const loadData = async (pageNumber: number) => {
    setLoading(true);
    const res = await fetchStixifyProfiles(pageNumber + 1); // Pass page number and size
    setData(res.data.results);
    setDataCount(res.data.count);
    setPageSize(10)
    setLoading(false);
  };

  // Load data on initial render and when the page changes
  useEffect(() => { loadData(page); }, [page]);

  const handlePageChange = (event: unknown, value: number) => {
    setPage(value); // Set new page number
  };


  useEffect(() => {
    document.title = 'Extraction Profiles List | Stixify Web'
  }, [])


  return (
    <Box p={4}>
      <Box sx={{ display: 'flex' }}>
        <Typography variant='h4'>Extraction Profiles</Typography>
      </Box>
      <Typography>
        <p>Extraction Profiles are selected during the upload of a report to define how the report should be treated when processed.</p>
        <p>You need at least one extraction profile to be able to upload reports.</p>
        <p>It is not possible to edit or delete an Extraction Profile. This is to ensure Extraction Profiles used to process are always accurate and accessible to view.</p>
      </Typography>

      <Table>
        <TableHead>
          <TableCell>ID</TableCell>
          <TableCell>Name</TableCell>
          <TableCell>Actions</TableCell>
        </TableHead>
        <TableBody>
          {loading ? (
            <TableRow>
              <TableCell colSpan={3}>
                <CircularProgress style={{ display: 'block', margin: '20px auto' }} />
              </TableCell>
            </TableRow>
          ) : (<>
            {data.map((profile) => (
              <TableRow key={profile.id}>
                <TableCell><Link to={URLS.staffProfileDetail(profile.id)}>{profile.id}</Link></TableCell>
                <TableCell><Link to={URLS.staffProfileDetail(profile.id)}>{profile.name}</Link></TableCell>
                <TableCell>
                  <Link style={{ marginRight: '2rem' }} to={URLS.staffReports({ profile_id: profile.id })}>
                    <Button variant='contained'>View Reports</Button>
                  </Link>
                </TableCell>
              </TableRow>
            ))}
          </>
          )}
        </TableBody>
      </Table>

      {/* Pagination controls */}
      <TablePagination
        component="div"
        count={dataCount}
        page={page}
        rowsPerPage={pageSize}
        onPageChange={handlePageChange}
        color="primary"
        rowsPerPageOptions={[]}
        labelRowsPerPage={""} // Hide the rows per page label
        style={{ marginTop: '20px', display: 'flex', justifyContent: 'center' }}
      />
    </Box>
  );
};

export default StixifyProfiles;
